import { Alert, ChakraProvider, Stack } from "@chakra-ui/react";

type Props = { message?: string };
export const GenericError: React.FC<Props> = ({ message }) => {
  return (
    <ChakraProvider>
      <Stack gap="4" width="full">
        <Alert status="error">{message}</Alert>
      </Stack>
    </ChakraProvider>
  );
};
